import { Reveal } from "@/components/Reveal";
import { LeadCTAs } from "@/components/LeadCTAs";
import { ImageDisclaimer } from "@/components/ImageDisclaimer";
import { CENTRAL_HEIGHTS } from "@/constants/content";
import { openLeadForm } from "@/utils/openLeadForm";

export const CentralHeightsAbout = () => {
  const { units } = CENTRAL_HEIGHTS;
  const totalUnits = units.reduce((n, u) => n + u.units, 0);

  return (
    <section id="central-heights" className="cp-section cp-section--white cp-heights-section" data-testid="central-heights-section">
      <div className="cp-container">
        <div className="cp-heights-about-grid">
          <Reveal>
            <span className="cp-eyebrow">Residential</span>
            <h2 className="cp-h2">
              Central Heights <em>Apartments</em>
            </h2>
            <div className="cp-about-points">
              <p>
                Alongside Central Plaza, Buildaxis Developers presents <strong>Central Heights</strong> —
                premium apartments at <strong>Sector 10A, Kharkhoda</strong>, designed for families and
                investors in NCR&apos;s fastest-growing industrial corridor.
              </p>
              <p>
                Spacious <strong>2 BHK</strong> and <strong>3 BHK</strong> homes with modern interiors,
                balconies, and the connectivity of the Buildaxis township master plan.
              </p>
            </div>
            <div className="cp-about-stats">
              <div>
                <strong>{totalUnits}</strong>
                <span>Apartment Units</span>
              </div>
              <div>
                <strong>2 &amp; 3</strong>
                <span>BHK Options</span>
              </div>
              <div>
                <strong>Kharkhoda</strong>
                <span>Sector 10A</span>
              </div>
            </div>
            <LeadCTAs
              className="cp-heights-pdf-btn"
              enquireTestId="central-heights-enquire-btn"
              waTestId="central-heights-whatsapp-btn"
            />
          </Reveal>

          <Reveal delay={0.1} className="cp-heights-feature-img">
            <img
              src="/brochure/central-heights/exterior-render.png"
              alt="Central Heights residential towers at Kharkhoda"
              loading="lazy"
            />
            <span>Residential apartments at Kharkhoda</span>
            <ImageDisclaimer />
          </Reveal>
        </div>

        <Reveal delay={0.12} className="cp-heights-rates-block">
          <div className="cp-heights-rates-head">
            <div>
              <h3 className="cp-heights-table-title">Flat Configurations</h3>
              <p className="cp-heights-rates-sub">
                Connect with our team for sizes, rates, and unit availability.
              </p>
            </div>
            {/* Rate pill hidden — share on enquiry
            <div className="cp-heights-rate-pill">...</div>
            */}
          </div>

          <div className="cp-heights-rate-cards" data-testid="central-heights-rates-table">
            {units.map((u) => (
              <article key={u.type} className="cp-heights-rate-card">
                <div className="cp-heights-rate-card-top">
                  <span className="cp-heights-rate-type">{u.type}</span>
                  <span className="cp-heights-rate-units">{u.units} units</span>
                </div>
                {u.summary && <p className="cp-heights-rate-blurb">{u.summary}</p>}
                {u.detail && <p className="cp-heights-rate-detail">{u.detail}</p>}
                <button
                  type="button"
                  className="btn btn-gold btn-sm cp-card-check-prices"
                  onClick={() =>
                    openLeadForm({
                      message: `Interested in Central Heights ${u.type} — please share pricing and availability.`,
                    })
                  }
                  data-testid={`central-heights-check-prices-${u.type.replace(/\s/g, "")}`}
                >
                  Check Prices
                </button>
              </article>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
};
